"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("./js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { viewBox: "0 0 1152 1152" },
      _react2.default.createElement("path", { fill: "#17D8FF", d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z" }),
      _react2.default.createElement("path", { fill: "#CBF0FE", d: "M330.5 465.3c28 0 54.3 10.9 74.1 30.8 19.8 19.9 30.7 46.3 30.7 74.5 0 28.1-10.9 54.6-30.7 74.5-19.8 19.9-46.1 30.9-74.1 30.9s-54.3-11-74.1-30.9-30.7-46.3-30.7-74.4c0-28.1 10.9-54.6 30.7-74.5 19.8-20 46.1-30.9 74.1-30.9zm244.8-246.1c28 0 54.3 11 74.1 30.9 40.8 41 40.8 107.9 0 148.9-19.8 19.9-46.1 30.8-74.1 30.8S521 418.9 501.2 399c-40.8-41.1-40.8-107.9 0-148.9 19.8-20 46.1-30.9 74.1-30.9zm-9.7 482.4c28 0 54.3 10.9 74.1 30.8 19.8 19.9 30.7 46.3 30.7 74.5 0 28.1-10.9 54.6-30.7 74.5s-46.1 30.9-74.1 30.9-54.3-11-74.1-30.9c-40.8-41.1-40.8-107.9 0-149 19.8-19.9 46.1-30.8 74.1-30.8zm244.8-226.2c22.6 0 44 8.9 60 25s24.9 37.5 24.9 60.3-8.8 44.2-24.9 60.4c-16 16.1-37.3 25-60 25s-44-8.9-60-25c-16-16.2-24.9-37.6-24.9-60.4 0-22.8 8.8-44.2 24.9-60.4 16-16 37.3-24.9 60-24.9zm-479.9-30.1c-31.9 0-63.8 12.2-88.1 36.7-48.7 48.9-48.7 128.3 0 177.2 24.3 24.4 56.2 36.7 88.1 36.7s63.8-12.2 88.1-36.7c46.2-46.5 48.5-120.4 6.9-169.7l70.5-69.8c20.8 17.9 46 27.7 71.6 29.7v232.2h-.5c-31.9 0-65.4 12.2-89.7 36.7-48.6 48.9-48.6 128.3 0 177.2 24.4 24.5 56.2 36.7 88.1 36.7 31.9 0 63.8-12.2 88.1-36.7 43.2-43.3 48.1-110.6 14.7-159.4l71.1-72.2c21.3 14.8 46 22.1 70.8 22.1 31.9 0 63.8-12.2 88.1-36.7 48.7-48.9 48.7-128.3 0-177.2-24.3-24.5-56.2-36.7-88.1-36.7-31.9 0-63.8 12.2-88.1 36.7-48.7 48.9-48.7 128.3 0 177.2l2.2 2.2-68.7 68.9-4.2-2.2c-19-19.1-42.6-30.7-67.2-34.9v-234c28.1-2.5 55.4-14.6 76.9-36.2 48.6-48.9 50.8-128.3 2.2-177.2-24.4-24.5-56.2-36.7-88.1-36.7-31.9 0-63.8 12.2-88.1 36.7-46.2 46.5-48.5 120.4-6.9 169.6l-69.1 69.6c-23.1-19.9-51.8-29.8-80.6-29.8zm535.1 113.2c0 29.5-19.1 55.6-53.5 56.3-36.3.7-56.1-24.1-56.1-53.6s24.8-56.8 54.1-56.8c29.4-.1 55.5 24.6 55.5 54.1z" })
    )
  );
};

WrappedIcon.displayName = 'AdobeTargetColorDark';
exports.default = WrappedIcon;

